import React from "react";
import {ItemField} from "../../../../Crudder/CrudModule";

import { FieldArray } from "react-final-form-arrays";
import StyledTextField from "../../../../Crudder/components/CrudDetail/StyledTextField";
import {FormApi} from "final-form";
import {Grid, Button, Box, Avatar, IconButton, InputAdornment} from "@material-ui/core";
import useStyles from "./styles";
import {useTheme} from "@material-ui/core/styles";
import {Delete} from "@material-ui/icons";
import { OfferResponse } from "../../../../Api/data/offer/types";
import {Field, useField} from "react-final-form";
import { InvoiceResponse } from "../../../../Api/data/invoice/types";

interface IInvoiceItemsFormPartProps {
    field: ItemField<any>,
    readonly?: boolean,
    form: FormApi,
    data?: InvoiceResponse,
}

const InvoiceItemsFormPart: React.FC<IInvoiceItemsFormPartProps> = ({ field, readonly , form, data}) => {
    const classes = useStyles();
    const theme = useTheme();

    return (
        <>
            <FieldArray name="items">
                {({ fields }) =>
                    fields.map((name, index) => (
                        <Box className={classes.itemRoot} key={`item-${name}`}>
                            <Box className={classes.itemNumber}>
                                <Avatar>{index + 1}</Avatar>
                                <Box className={classes.itemMenuHolder}>
                                    <IconButton
                                        aria-label="delete"
                                        onClick={() => fields.remove(index)}
                                        size={"medium"}
                                    >
                                        <Delete />
                                    </IconButton>
                                </Box>
                            </Box>
                            <Grid className={classes.itemForm} container spacing={3} key={name}>
                                <Grid item xs={4}>
                                    <StyledTextField
                                        name={`${name}.title`}
                                        label={"Nadpis"}
                                    />
                                </Grid>

                                <Field name="transferredVAT">
                                    {transferredVATProps => (
                                        <Field name="currency">
                                            {props => (
                                                <>
                                                    <Grid item xs={2}>
                                                        <StyledTextField
                                                            name={`${name}.price`}
                                                            type={"number"}
                                                            label={"Cena"}
                                                            InputProps={{
                                                                endAdornment: <InputAdornment position="end">{props.input.value?.alpha3Code}</InputAdornment>,
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        {
                                                            transferredVATProps.input.value ? (
                                                                <StyledTextField
                                                                    name={`${name}.vatRate0`}
                                                                    type={"number"}
                                                                    label={"Sazba DPH"}
                                                                    disabled={true}
                                                                    InputProps={{
                                                                        value: "0",
                                                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                                    }}
                                                                />
                                                            ) : (
                                                                <StyledTextField
                                                                    name={`${name}.vatRate`}
                                                                    type={"number"}
                                                                    label={"Sazba DPH"}
                                                                    InputProps={{
                                                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                                    }}
                                                                />
                                                            )
                                                        }
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                                <StyledTextField
                                                                    name={`${name}.vat`}
                                                            type={"number"}
                                                                    label={"DPH"}
                                                                    InputProps={{
                                                                        endAdornment: <InputAdornment position="end">{props.input.value?.alpha3Code}</InputAdornment>,
                                                                        readOnly: true
                                                                    }}
                                                                />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <StyledTextField
                                                            name={`${name}.priceVat`}
                                                            type={"number"}
                                                            label={"Cena s DPH"}
                                                            InputProps={{
                                                                endAdornment: <InputAdornment position="end">{props.input.value?.alpha3Code}</InputAdornment>,
                                                                readOnly: true
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            )}
                                        </Field>
                                    )}
                                </Field>
                                <Grid item xs={12} style={{paddingTop: 0}}>
                                    <StyledTextField
                                        name={`${name}.description`}
                                        multiline={true}
                                        rows={3}
                                        label={"Popis"}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                    ))
                }
            </FieldArray>
        </>
    );
}
export default InvoiceItemsFormPart;